import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Delay charge per minute.
 */
export const schema = z.number().nonnegative().max(1);

export type DelayPricePerMinute = z.infer<typeof schema>;

export const definition = define({
  key: 'delay_price_per_minute',
  schema,
  label: 'Delay Price Per Minute',
  description:
    'Amount to charge clients at this level per each minute our driver is delayed. This only applies when we choose to specifically charge clients at this level for the delay. Min: $0.00, Max: $1.00.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.PRICING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.REGION, LEVELS.ORGANIZATION, LEVELS.CUSTOMER, LEVELS.RATERULEGROUP],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 0.33,
});
